import { IIndexable } from "@customtypes/common";

import {
  ApeswapIcon,
  BeefyIcon,
  DeriIcon,
  EllipsisIcon,
  KalmyIcon,
  MagpieIcon,
  MidasDarkIcon,
  MidasLightIcon,
  OpenLeverageIcon,
  ReaperFarmIcon,
  SwapfishIcon,
  TarotIcon,
  ThenaIcon,
  WombatIcon,
  WombexIcon,
  QuollIcon,
  AaveIcon,
  BalancerIcon,
  CianIcon,
  MeshswapIcon,
  DeltaIcon,
  QidaoIcon,
  QuickswapIcon,
  Dystopia,
  Ovix,
  OliveIcon,
  PancakeswapIcon,
  Ledger,
  PlanetIcon,
  Venus,
  Mdex,
} from "icons";

// DefiIcons Mapping (Key should be matched with strapi)
export const defiIcons: IIndexable = {
  // BNB
  mdex: {
    light: Mdex,
    dark: Mdex,
  },
  venus: {
    light: Venus,
    dark: Venus,
  },
  apeswap: {
    light: ApeswapIcon,
    dark: ApeswapIcon,
  },
  quoll: {
    light: QuollIcon,
    dark: QuollIcon,
  },
  beefy: {
    light: BeefyIcon,
    dark: BeefyIcon,
  },
  deri: {
    light: DeriIcon,
    dark: DeriIcon,
  },
  tarot: {
    light: TarotIcon,
    dark: TarotIcon,
  },
  ellipsis: {
    light: EllipsisIcon,
    dark: EllipsisIcon,
  },
  kalmy: {
    light: KalmyIcon,
    dark: KalmyIcon,
  },
  magpie: {
    light: MagpieIcon,
    dark: MagpieIcon,
  },
  midas: {
    light: MidasLightIcon,
    dark: MidasDarkIcon,
  },
  openleverage: {
    light: OpenLeverageIcon,
    dark: OpenLeverageIcon,
  },
  reaper: {
    light: ReaperFarmIcon,
    dark: ReaperFarmIcon,
  },
  swapfish: {
    light: SwapfishIcon,
    dark: SwapfishIcon,
  },
  thena: {
    light: ThenaIcon,
    dark: ThenaIcon,
  },
  wombat: {
    light: WombatIcon,
    dark: WombatIcon,
  },
  wombex: {
    light: WombexIcon,
    dark: WombexIcon,
  },
  pancakeswap: {
    light: PancakeswapIcon,
    dark: PancakeswapIcon,
  },
  planet: {
    light: PlanetIcon,
    dark: PlanetIcon,
  },

  // Polygon
  aave: {
    light: AaveIcon,
    dark: AaveIcon,
  },
  balancer: {
    light: BalancerIcon,
    dark: BalancerIcon,
  },
  dystopia: {
    light: Dystopia,
    dark: Dystopia,
  },
  cian: {
    light: CianIcon,
    dark: CianIcon,
  },
  meshswap: {
    light: MeshswapIcon,
    dark: MeshswapIcon,
  },
  delta: {
    light: DeltaIcon,
    dark: DeltaIcon,
  },
  qidao: {
    light: QidaoIcon,
    dark: QidaoIcon,
  },
  quickswap: {
    light: QuickswapIcon,
    dark: QuickswapIcon,
  },
  ovix: {
    light: Ovix,
    dark: Ovix,
  },
  olive: {
    light: OliveIcon,
    dark: OliveIcon,
  },
  ledger: {
    light: Ledger,
    dark: Ledger,
  },
};

export enum PartnerTypes {
  DEX = "dex",
  VAULT = "vault",
  YIELD_OPTIMIZER = "yo",
  LENDING_BORROWING = "lb",
  LEVERAGE_TADING = "lt",
  OPTION_TADING = "ot",
}
